export default __webpack_public_path__ + "static/media/community.c5a67801.png";